import React, { memo } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const NotarizationRequestConfirmationModal = memo(
  ({ open, setOpen, onConfirm, loading }) => {
    return (
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: 400,
            width: "85vw",

            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: { xs: 1, sm: 2 },
          }}
        >
          <Typography variant="h6" component="h2">
            Are you sure you want to submit?
          </Typography>
          <Typography sx={{ mt: 2 }}>
            You will not be able to modify your signer information after this
            point.
          </Typography>
          <Box
            sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button
              disabled={loading}
              sx={{ mr: 1 }}
              fullWidth
              color="error"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <LoadingButton
              loading={loading}
              sx={{ ml: 1 }}
              fullWidth
              variant="contained"
              color="success"
              onClick={onConfirm}
            >
              Yes, Submit
            </LoadingButton>
          </Box>
        </Box>
      </Modal>
    );
  },
);

export default NotarizationRequestConfirmationModal;
